import React, { createContext, useState } from 'react';

export const LangContext = createContext();

// Toutes les traductions en français uniquement
const translations = {
  // Auth
  login: 'Connexion',
  register: 'Inscription',
  logout: 'Déconnexion',
  email: 'Email',
  password: 'Mot de passe',
  name: 'Nom complet',
  name_placeholder: 'Jean Dupont',
  remember_me: 'Se souvenir de moi',
  forgot_password: 'Mot de passe oublié ?',
  create_account: 'Créez votre compte',
  already_have_account: 'Déjà inscrit ?',
  no_account: 'Pas encore de compte ?',
  invalid_credentials: 'Identifiants invalides',
  register_error: "Erreur lors de l'inscription",
  password_min_length: 'Le mot de passe doit contenir au moins 6 caractères',
  passwords_no_match: 'Les mots de passe ne correspondent pas',
  accept_terms_required: 'Vous devez accepter les conditions',
  platform_tagline: 'Plateforme de collaboration créative',
  
  // Navigation
  feed: 'Accueil',
  projects: 'Projets',
  services: 'Services',
  my_applications: 'Candidatures',
  my_projects: 'Mes Projets',
  admin: 'Administration',
  notifications: 'Notifications',
  profile: 'Profil',
  settings: 'Paramètres',
  
  // Password strength
  weak: 'Faible',
  medium: 'Moyen',
  strong: 'Fort',
  
  // Status
  pending: 'En attente',
  accepted: 'Acceptée',
  rejected: 'Refusée',
  in_progress: 'En cours',
  resolved: 'Résolu',
  
  // Actions
  submit: 'Envoyer',
  cancel: 'Annuler',
  save: 'Sauvegarder',
  delete: 'Supprimer',
  edit: 'Modifier',
  view: 'Voir',
  apply: 'Postuler',
  
  // Common
  loading: 'Chargement...',
  no_results: 'Aucun résultat',
  error: 'Erreur',
  success: 'Succès'
};

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState('fr');
  // Retourne toujours la traduction française
  const t = (key) => translations[key] || key;
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};
